import React from "react";
import { Table, Tag } from "antd";

const Orders = () => {
    const columns = [
        { title: "Produit", dataIndex: "product" },
        { title: "Quantité", dataIndex: "qty" },
        {
            title: "Statut",
            dataIndex: "status",
            render: (status) => <Tag color="blue">{status}</Tag>,
        },
    ];

    const data = [
        { key: 1, product: "Maïs", qty: "100kg", status: "En attente" },
        { key: 2, product: "Riz", qty: "50kg", status: "Livré" },
    ];

    return <Table columns={columns} dataSource={data} />;
};

export default Orders;